import React, { Fragment, useEffect, useState } from "react";

import {
  Typography
} from "@mui/material";
import { Card, Col, Container, Row } from "reactstrap";

import { Icon } from "@progress/kendo-react-common";
import { advanceSearch } from "../../_helper/services/advanceSearchv2";
import ErrorBoundary from "../../ErrorBoundry";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { loadingPanel } from "../../CommonComponents/CommonFunction";

function BenefitLifeStatistics() {
  const options = {
    chart: {
      type: "pie",
      events: {
        drilldown: function (e) {
          this.update({
            drilldown: {
              breadcrumbs: {
                position: {
                  align: 'left'
                }
              }
            }
          });
        },
        drillup: function (e) {
          this.update({
            drilldown: {
              breadcrumbs: {
                position: {
                  align: 'left'
                }
              }
            }
          });
        }
      }
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
      point: {
        valueSuffix: "",
      },
    },

    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        showInLegend: true,
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}:{point.y}</b>",
        },
      },
      series: {
        borderRadius: 5,
        // dataLabels: [
        //   {
        //     enabled: true,
        //     distance: 15,
        //     format: "{point.name}",
        //   },
        //   {
        //     enabled: true,
        //     distance: "-30%",
        //     filter: {
        //       property: "percentage",
        //       operator: ">",
        //       value: 5,
        //     },
        //     format: "{point.y:.1f}%",
        //     style: {
        //       fontSize: "0.9em",
        //       textOutline: "none",
        //     },
        //   },
        // ],
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: ' +
        "<b>{point.y}</b><br/>",
    },
  };
  const [optionDental, setOptionsDental] = useState(options);
  const [optionHealth, setOptionsHealth] = useState(options);
  const [isDentalLoading, setIsDentalLoading] = useState(false);
  const [isHealthLoading, setIsHealthLoading] = useState(false);

  const getLifeData = async () => {
    setIsDentalLoading(true)
    const payload = {
      tableName: "vw_benefit_life_statistics",
      searchParams: "[]",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000,
      sortData: "",
      additionalWhere: "",
      location: "Benefits-global",
    };
    try {
      const response = await advanceSearch(payload, 'Benefits');
      const { results } = response;
      const compnayAarray = results
        .filter((i) => !i.level_1 && !i.level_2)
        .map((item) => {
          return {
            name: item.title,
            y: item.total,
            drilldown: item.title,
            code: item.level_1,
          };
        });
      const compnayDrillDown = compnayAarray.filter((i) => i.name != 'Basic Insurance').map((item) => {
        return {
          id: item.name,
          name: item.name,
          data: results
            .filter((i) => i.level_1 && !i.level_2 && item.name == i.level_1)
            .map((i) => {
              return {
                name: i.title,
                y: i.total,
                drilldown: i.title + "-" + i.level_1,
              };
            }),
          // drilldown:
        };
      });
      const otherDilldown = results
        .filter((i) => i.level_1 && i.level_2)
        .map((item) => {
          return {
            id: item.level_2 + "-" + item.level_1,
            name: item.title,
            data: results
              .filter(
                (i) =>
                  i.level_1 &&
                  i.level_2 &&
                  i.level_2 == item.level_2 &&
                  i.level_1 == item.level_1
              )
              .map((i) => {
                return { name: i.title, y: i.total };
              }),
          };
        });

      console.log("fdsafsdafdsfsdaffdsaf : ", compnayAarray, compnayDrillDown, otherDilldown)
      setOptionsDental({
        ...optionDental,
        title: {
          text: "Life Insurance Statistics",
          align: "center",
        },
        series: [
          {
            name: "Life Insurance",
            colorByPoint: true,
            data: compnayAarray,
          },
        ],
        drilldown: {
          series: [...compnayDrillDown, ...otherDilldown],
        },
      });
      // setRowCount(rowCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsDentalLoading(false)

      // setLoading(false);
    }
  };

  useEffect(() => {
    getLifeData();
  }, []);

  return (
    <ErrorBoundary>
      {" "}
      <Fragment>

        {isDentalLoading || isHealthLoading
          ? loadingPanel()
          : null}
        <Container fluid={true}>
          <Row className="bg-primary rounded py-3 mb-3">
            <Col md={6}>
              <Typography variant="h5">
                <Icon
                  style={{ fontSize: "25px", margin: "10px" }}
                  name="graph"
                />
                Benefits Life Insurance Statistics
              </Typography>
            </Col>
          </Row>

          <Row>
            {/* <Col md={6}>
              <Card className="p-3">
                <HighchartsReact highcharts={Highcharts} options={optionHealth} />
              </Card>
            </Col> */}
            <Col md={6}>
              <Card className="p-3">
                <HighchartsReact highcharts={Highcharts} options={optionDental} />
              </Card>
            </Col>
          </Row>
          <Row></Row>
        </Container>
      </Fragment>
    </ErrorBoundary>
  );
}
export default BenefitLifeStatistics;
